import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { getProviderImages, addProviderImages, deleteProviderImage, updateProviderImage } from "../slice/providerPanelImageSlice";

const ProviderPanelImage = () => {
  const dispatch = useDispatch();
  const { providerImages } = useSelector((state) => state.providerImages);
  const [showModal, setShowModal] = useState(false);
  const [selectedImages, setSelectedImages] = useState([]);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [imageToUpdate, setImageToUpdate] = useState(null);
  const [updatedImageFile, setUpdatedImageFile] = useState(null);


  const providerToken = localStorage.getItem("provider_access_token");

  useEffect(() => {
    dispatch(getProviderImages(providerToken));
  }, [dispatch]);

  const handleAddImages = () => {
    setSelectedImages([]);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const openUpdateModal = (img) => {
    setImageToUpdate(img);
    setUpdatedImageFile(null); // reset selected file
    setShowUpdateModal(true);
  };

  const closeUpdateModal = () => {
    setShowUpdateModal(false);
    setImageToUpdate(null);
    setUpdatedImageFile(null);
  };

  const handleSubmitImages = async () => {
    if (selectedImages.length === 0) {
      toast.error("Please select at least one image.");
      return;
    }

    const formData = new FormData();
    selectedImages.forEach((file) => {
      formData.append("images", file);
    });

    for (let pair of formData.entries()) {
      console.log(pair[0], pair[1]);
    }

    const result  = await dispatch(addProviderImages({ token: providerToken, data: formData }))
    if (result.meta.requestStatus === "fulfilled") {
      setShowModal(false);
      toast.success("Images uploaded successfully!");
      dispatch(getProviderImages(providerToken));
    } else {
      toast.error("Failed to upload images.");
    }
  };

  const handleUpdateImage = () => {
    if (!updatedImageFile) {
      toast.error("Please select an image to update.");
      return;
    }

    const formData = new FormData();
    formData.append("images", updatedImageFile);

    dispatch(updateProviderImage({ token: providerToken, imageId: imageToUpdate.id, data: formData }))
    .then(() => {
      toast.success("Image updated successfully!");
      dispatch(getProviderImages(providerToken));
      closeUpdateModal();
    })
    .catch(() => {
      toast.error("Failed to update image.");
    });
  };

  const handleDeleteImage = async (imageId) => {
    if (!window.confirm("Are you sure you want to delete this image?")) return;

    const result = await dispatch(deleteProviderImage({ token: providerToken, imageId }))
      if (result.meta.requestStatus === "fulfilled") {
        toast.success("Image deleted successfully!", {
          position: "top-right",
          autoClose: 2000,
          style: { fontSize: "0.85rem" },
        });
        dispatch(getProviderImages(providerToken));
      } else {
        toast.error("Failed to delete image.", {
          position: "top-right",
          autoClose: 2000,
          style: { fontSize: "0.85rem" },
        });
      }
  };

  return (
    <>
    <style>{`
      .modal-backdrop-custom {
          position: fixed;
          top: 0;
          left: 0;
          z-index: 1040;
          width: 100vw;
          height: 100vh;
          background-color: rgba(0, 0, 0, 0.5);
      }
    `}
    </style>

    {showModal && <div className="modal-backdrop-custom"></div>}
      <div className="col-md-8 col-xl-9 mt-4 mt-md-0">
        <div className="ps-2 ps-lg-4">
          <h4 className="font-weight-bold text-primary font-size-40 mb-4 pb-1 line-hight-2 border-bottom pb-3 montserrat d-flex">
            My Images
            <button className="btn btn-danger ms-auto py-2 " onClick={handleAddImages}>
              <i className="fa fa-user-plus me-1"></i> Add Images
            </button>
          </h4>
          <div className="row g-3 row-cols-2 row-cols-sm-3 row-cols-md-3 row-cols-lg-4 g-lg-4">
            {Array.isArray(providerImages) && providerImages.length > 0 ? (
              providerImages.map((img) => (
                <div className="col my-images-row" key={img.id}>
                  <div className="image-card position-relative">
                    <img
                      src={`${process.env.REACT_APP_PROVIDER_IMAGE_BACKEND_URL}/${img.image_name}`}
                      className="rounded w-100"
                      alt="Provider"
                      style={{
                        height: "250px"
                      }}
                      onError={(e) => {
                        e.target.onerror = null; // Prevent infinite loop
                        e.target.src = `${process.env.REACT_APP_PROVIDER_IMAGE_BACKEND_URL}`+'/default.png'; // <- Change to your default image path
                      }}
                    />
                    <div class="image-overlay position-absolute top-50 start-50 translate-middle">
                      <a href="#" class="bg-white text-primary rounded-pill p-1" onClick={() => openUpdateModal(img)}><i class="fa font-size-18 fa-pencil"></i></a>
                      <a href="#" class="bg-white text-primary rounded-pill p-1 ms-2" onClick={() => handleDeleteImage(img.id)}><i class="fa fa-trash font-size-20"></i></a>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="col">
                <p>No images found.</p>
              </div>
            )}
          </div>
          <div
            className={`modal fade ${showModal ? "show" : ""}`}
            style={{ display: showModal ? "block" : "none" }}
            tabIndex="-1"
            aria-labelledby="editServiceModalLabel"
            aria-hidden={!showModal}
          >
            <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="font-weight-bold text-primary font-size-24 line-hight-2 montserrat d-flex" id="editServiceModalLabel">
                  Add Image
                </h5>

                <button
                  type="button"
                  className="btn-close"
                  onClick={handleCloseModal}
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                <div className="row g-3">
                  
                  
                
                  <div className="col-sm-12">
                    <label className="form-label text-primary mb-1 font-weight-semibold required">Upload Image</label>
                    
                    <div className="d-flex flex-column flex-md-row w-100 gap-3 align-items-start">
                      {/* Upload Field */}
                      <div className="uploadfield flex-fill">
                        <div className="custom-file-upload position-relative">
                          <button
                            type="button"
                            className="upload-btn btn btn-custom-primary position-absolute"
                            onClick={() => document.getElementById('profileImage')?.click()}
                          >
                            Upload Files
                          </button>
                          <input
                            type="file"
                            name="profile_image"
                            id="profileImage"
                            accept=".jpg,.jpeg,.png"
                            multiple
                            onChange={(e) => {
                              const filesArray = Array.from(e.target.files);
                              setSelectedImages((prev) => [...prev, ...filesArray]);
                            }}
                          />
                        </div>
                        <div className="file-name form-control" id="fileName" style={{ height: "auto" }}>
                          {selectedImages.length > 0
                            ? selectedImages.map((file, index) => <div key={index}>{file.name}</div>)
                            : "No file chosen"}
                        </div>
                      </div>
                    </div>
                  </div>
                
                </div>
                    <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={handleCloseModal}
                >
                  Close
                </button>
                    <button className="btn btn-custom-primary" onClick={handleSubmitImages}>
                      Upload
                    </button>
              </div>
              </div>
            </div>
        </div>
      </div>
      {showUpdateModal && (
        <div className="modal fade show" style={{ display: "block" }} tabIndex="-1" aria-modal="true" role="dialog">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Update Image</h5>
                <button type="button" className="btn-close" onClick={closeUpdateModal} aria-label="Close"></button>
              </div>
              <div className="modal-body">
                <div className="row g-3">
                  
                  
                
                  <div className="col-sm-12">
                    <label className="form-label text-primary mb-1 font-weight-semibold required">Upload Image</label>
                    
                    <div className="d-flex flex-column flex-md-row w-100 gap-3 align-items-start">
                      {/* Upload Field */}
                      <div className="uploadfield flex-fill">
                        
                          {imageToUpdate && (
                  <div className="mb-3 text-center">
                                <img
                                  src={`${process.env.REACT_APP_PROVIDER_IMAGE_BACKEND_URL}/${imageToUpdate.image_name}`}
                                  alt="Current"
                                  style={{ maxWidth: "100px", maxHeight: "100px", borderRadius: "4px"}}
                                />
                              </div>
                            )}
                            <div className="custom-file-upload position-relative">
                          <button
                            type="button"
                            className="upload-btn btn btn-custom-primary position-absolute"
                            onClick={() => document.getElementById('profileUpdateImage')?.click()}
                          >
                            Upload Files
                          </button>
                          <input
                            type="file"
                            name="profile__update_image"
                            id="profileUpdateImage"
                            accept=".jpg,.jpeg,.png"
                            onChange={(e) => setUpdatedImageFile(e.target.files[0])}
                          />
                        </div>
                        <div className="file-name form-control" id="fileName" style={{ height: "auto" }}>
                          {updatedImageFile
                            ? <div>{updatedImageFile.name}</div>
                            : "No file chosen"}
                        </div>
                      </div>
                    </div>
                  </div>
                
                </div>
                    

              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={closeUpdateModal}>Close</button>
                <button className="btn btn-custom-primary" onClick={handleUpdateImage}>Update</button>
              </div>
            </div>
          </div>
        </div>
      )}
        </div>
      </div>
    </>
  );
};

export default ProviderPanelImage;
